import React from "react";
import styles from "./index.module.scss";

export type ClickType = "points" | "coupons";

interface MemberInfoCardProps {
  username?: string;
  points?: number;
  coupons?: number;
  isLogin?: boolean;
  onClick?: (
    type: ClickType,
    data: { points?: number; coupons?: number }
  ) => void;
}

const MemberInfoCard: React.FC<MemberInfoCardProps> = ({
  username,
  points = 0,
  coupons = 0,
  onClick,
}) => {
  return (
    <div className={styles.memberInfoCard}>
      <div className={styles.bgImage}>
        <div className={styles.header}>
          <div className={styles.greeting}>Hi, {username}</div>
          <div className={styles.bookmarkIcon}>
            <div className={styles.icon}></div>
          </div>
        </div>
        <div className={styles.statsContainer}>
          <div
            className={styles.statItem}
            onClick={() => onClick?.("points", { points, coupons })}
          >
            <div className={styles.statValue} data-element-id="my-points">
              {points}
            </div>
            <div className={styles.statLabel} data-element-id="my-points-label">
              My Points
            </div>
          </div>

          <div
            className={styles.statItem}
            onClick={() => onClick?.("coupons", { points, coupons })}
          >
            <div className={styles.statValue} data-element-id="my-coupons">
              {coupons}
            </div>
            <div
              className={styles.statLabel}
              data-element-id="my-coupons-label"
            >
              My Coupons
            </div>
          </div>
        </div>
      </div>
      <div className={styles.bottomDecoration}></div>
    </div>
  );
};

export default MemberInfoCard;
